import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {cross} from 'react-icons-kit/icomoon/cross';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import WaitingModal from '../../generics/WaitingModal';
import Help from '../../generics/help';

var Config = require('../../../config');
class LockUnits extends Component{
	constructor(props){
		super(props);

		this.filter = this.filter.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.getList = this.getList.bind(this);

		this.state = {
			filterText:"",
			units:[],
			columns:[]
		}
	}

	componentDidMount(){
		this.getList();
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'units_locked/list?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({units:response})
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}


	newEntry(){
		this.props.history.push('/lock_units/new');
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.unit_number !== null &&
				row.component !== null &&
				row.component_number !== null &&
				row.group_rh !== null
			){
				if(
					row.unit_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.component.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.component_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.group_rh.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 
					
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	onDelete(id){
		var msg = '<p>Estas seguro que quieres desbloquear la unidad</p>';
		
		swal({
	        title: '',
	        text: msg,
	        html: true,
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, (isConfirm)=> {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'units_locked/'+id,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'La unidad se desbloqueo correctamente.', 'success');
					}
				})
	        }
	    });
	}


	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						Bloqueo de Unidades
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_lock_units"}  />
			                
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-3">
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>

						<div className="col-xs-12 col-sm-4">
							
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px"}}
								disabled={!this.props.task_units_locked.create}>
								Nuevo
							</button>
						</div>
						
					</div>
					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Fecha</th>
									<th>Unidad</th>
									<th>Componente</th>
									<th>No. Componente</th>
									<th>Grupo & RH</th>
									<th>Volumen</th>
									<th>Caducidad</th>
									<th>Motivo</th>
									<th>Estatus</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{this.state.units.map((unit, i)=>(
									this.filter(unit) === true ?
										<tr key={i}>
											<td>{moment(unit.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')} </td>
											<td>{unit.unit_number}</td>
											<td>{unit.component}</td>
											<td>{unit.component_number}</td>
											<td>{unit.group_rh}</td>
											<td>{unit.volume}</td>
											<td>{moment(unit.caducidad, 'YYYY-MM-DDTH:mm:ss').format('DD/MM/YYYY HH:mm')} </td>
											<td>{unit.reason_to_lock}</td>
											<td>{unit.status}</td>
											<td>
							                    <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} 
													disabled={!this.props.task_units_locked.delete}
													onClick={this.onDelete.bind(this, unit.unit_id)}>
													<SvgIcon icon={cross} className="icon-align"/>
												</FloatingActionButton>
												
											</td>
										</tr>
									: null
								))}
							</tbody>
						</Table>
					</div>
					<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				</form>

				
			</div>
		)
	}
}

export default translate('translations') (LockUnits);